export enum DashBuilderStatus {
  Default = '',
  Completed = 'completed',
  Error = 'error',
  Pending = 'pending',
}
export interface RealTimeContextData {
  yDocRef: React.MutableRefObject<any>
  dashMapRef: React.MutableRefObject<any>
  dashMapSectionsRef: React.MutableRefObject<any>
  isHocusPocusConnected: boolean
  updateDashboardTheme: (theme: any) => void
  sendStateless: (operationType: string, operationPayload: any) => void
  connectedUsers: any[]
  handleUndoRedo: (action: string) => void
  resetUndoManager: () => void
  updateUserState: (state: any) => void
  dashBuilderStatus: DashBuilderStatus
}
